export class ProjectOverviewData {
  title: string;
  value: string;
}
